module.exports = __webpack_public_path__ + "static/media/paracetamol.03c4ba07.png";